/// <reference types="vite/client" />
/* eslint-disable no-console -- logger is the single place that forwards to console in dev */
/**
 * Minimal logger abstraction (ARCHITECTURE §3).
 * In development: forwards to console. In production: no-op for debug/info;
 * warn/error no-op by default (plug in error reporting later if needed).
 * Logging only runs when import.meta.env.DEV is true (e.g. "npm run dev"); production/preview builds no-op all levels.
 */
const isDev = import.meta.env.DEV;

function noop(_message?: string, ..._args: unknown[]): void {}

function devLog(
  level: 'debug' | 'info' | 'warn' | 'error',
  message: string,
  ...args: unknown[]
): void {
  if (!isDev) return;
  const fn =
    level === 'error'
      ? console.error
      : level === 'warn'
        ? console.warn
        : console.log;
  if (args.length > 0) {
    fn(`[${level}]`, message, ...args);
  } else {
    fn(`[${level}]`, message);
  }
}

export const logger = {
  debug: isDev
    ? (message: string, ...args: unknown[]) => devLog('debug', message, ...args)
    : noop,
  info: isDev
    ? (message: string, ...args: unknown[]) => devLog('info', message, ...args)
    : noop,
  warn: isDev
    ? (message: string, ...args: unknown[]) => devLog('warn', message, ...args)
    : noop,
  error: isDev
    ? (message: string, ...args: unknown[]) => devLog('error', message, ...args)
    : noop,
};
